import { render, staticRenderFns } from "./ModalDownloadDokumen.vue?vue&type=template&id=18aa5d20&"
import script from "./ModalDownloadDokumen.vue?vue&type=script&lang=js&"
export * from "./ModalDownloadDokumen.vue?vue&type=script&lang=js&"
import style0 from "./ModalDownloadDokumen.vue?vue&type=style&index=0&id=18aa5d20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports